import { render, staticRenderFns } from "./WhdBusiness.vue?vue&type=template&id=3084f4d6&lang=pug&"
import script from "./WhdBusiness.vue?vue&type=script&lang=js&"
export * from "./WhdBusiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports